// 個別作業員のグリーンサイトスクレイピング進捗ポーリング
// 差分チェックボタンクリック → スクレイプ要求 → 完了までポーリング → 結果表示・リロード
function setupWorkerScrapePolling(root) {
  root = root || document;
  var $ = window.jQuery;

  var btnEl = root.querySelector('.js-single-scrape-btn');
  if (!btnEl || !$ || !$.fn || !$.fn.toast) return;

  var statusUrl = btnEl.getAttribute('data-status-url');
  if (!statusUrl) return;

  var POLL_INTERVAL_MS = 3000;
  var MAX_POLL_ATTEMPTS = 100; // 約5分（3秒×100回）でタイムアウト
  var pollInterval = null;
  var pollInflight = false;
  var pollAttempts = 0;

  function stopPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
    pollInflight = false;
    pollAttempts = 0;
  }

  // ページ離脱時にタイマーを停止（メモリリーク・無駄なリクエスト防止）
  $(window).on('beforeunload pagehide', stopPolling);

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  function showToast(message, klass) {
    $('body').toast({
      message: message,
      class: klass || 'teal',
      showProgress: 'bottom'
    });
  }

  function startPolling(btn) {
    stopPolling();
    pollInterval = setInterval(function () {
      // 前回のリクエストがまだ進行中ならスキップ（重複防止）
      if (pollInflight) return;

      pollAttempts += 1;
      if (pollAttempts > MAX_POLL_ATTEMPTS) {
        stopPolling();
        btn.removeClass('loading disabled').prop('disabled', false);
        showToast('差分チェックがタイムアウトしました。後で再試行してください。', 'warning');
        return;
      }

      pollInflight = true;
      fetch(statusUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (resp) { return resp.json(); })
        .then(function (data) {
          pollInflight = false;
          if (data.status === 'success' || data.status === 'error') {
            stopPolling();
            btn.removeClass('loading disabled').prop('disabled', false);
            if (data.status === 'success') {
              var msg = data.has_difference
                ? '差分チェックが完了しました。差分があります。'
                : '差分チェックが完了しました。差分はありません。';
              showToast(msg, 'teal');
            } else {
              showToast('差分チェックでエラーが発生しました', 'error');
            }
            setTimeout(function () { location.reload(); }, 1200);
          }
        })
        .catch(function () {
          pollInflight = false; // ネットワーク一時エラーは次回リトライ
        });
    }, POLL_INTERVAL_MS);
  }

  $(root).on('click', '.js-single-scrape-btn', function () {
    var btn = $(this);
    var workerName = btn.attr('data-worker-name') || '作業員';
    if (!confirm(workerName + 'の差分チェックを実行しますか？')) return;

    btn.addClass('loading disabled').prop('disabled', true);

    fetch(btn.attr('data-url'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
        'Accept': 'application/json'
      },
      body: JSON.stringify({})
    })
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        if (data.ok) {
          showToast(data.message || '差分チェック中...', 'blue');
          startPolling(btn);
        } else {
          btn.removeClass('loading disabled').prop('disabled', false);
          showToast(data.error || 'エラーが発生しました', 'error');
        }
      })
      .catch(function (err) {
        btn.removeClass('loading disabled').prop('disabled', false);
        showToast('リクエストに失敗しました: ' + err.message, 'error');
      });
  });
}

$(function () {
  setupWorkerScrapePolling(document);
});
